import { Reader } from 'jsmediatags';
import XhrFileReader from 'jsmediatags/build2/XhrFileReader';
import { CallbackType, LoadCallbackType } from 'jsmediatags/types';

export default class XhrFileReaderWithLength extends XhrFileReader {
  static urlToSizeMap: {
    [index: string]: number;
  } = {};

  static read(url: string, callbacks: CallbackType) {
    new Reader(url)
      .setFileReader(XhrFileReaderWithLength)
      .setTagsToRead([
        // ID3v2.4/2.3 frame ids, their ID3v2.2 three character equivalents,
        // and the MP4 atoms. jsmediatags normalises nine of these to readable
        // names via its SHORTCUTS table (title, artist, album, year, comment,
        // track, genre, picture, lyrics); everything else arrives under its
        // raw frame id with a .description from the ID3 spec attached.
        'TIT2',
        'TT2',
        '©nam', // title
        'TPE1',
        'TP1',
        '©ART', // artist
        'TALB',
        'TAL',
        '©alb', // album
        'TYER',
        'TYE',
        '©day', // year
        // v2.4 release time. libraryService prefers it over TYER, but it was
        // never in this list, so that branch could not fire.
        'TDRL',
        'COMM',
        'COM',
        '©cmt', // comment
        'TRCK',
        'TRK',
        'trkn', // track number
        'TCON',
        'TCO',
        '©gen',
        'gnre', // genre
        'TPE2',
        'TP2',
        'aART', // album artist
        'TCOM',
        'TCM',
        '©wrt', // composer
        'TPOS',
        'TPA',
        'disk', // part of a set / disc number
        'TBPM',
        'TBP',
        'tmpo', // beats per minute
        'TKEY',
        'TKE', // initial key
        'TPUB',
        'TPB', // publisher / label
        'CNT', // play counter
        'cpil', // compilation
        // Deliberately not read: USLT/ULT/©lyr. Lyrics are unbounded text and
        // would dwarf the rest of the library file - see docs/TAG-EDITING.md.
      ])
      .read(callbacks);
  }

  constructor(url: string) {
    super(url);

    if (XhrFileReaderWithLength.urlToSizeMap[this._url]) {
      this._size = XhrFileReaderWithLength.urlToSizeMap[this._url];
    }
  }

  _init(callbacks: LoadCallbackType) {
    if (this._size) {
      this._isInitialized = true;
      callbacks.onSuccess();
    } else {
      if (callbacks.onError)
        callbacks.onError({
          type: 'XhrFileReaderWithLength',
          info: 'Missing size, did you map the provided url to size? Set XhrFileReaderWithLength.urlToSizeMap before usage.',
        });
    }
  }
}
